import { EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const PEVC_DEALFLOW_EDGES: Record<string, EdgeDefinition> = {
  DEAL_FOR: {
    type: 'DEAL_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Deal For',
    reverseDisplayName: 'Has Deal',
    sourceTypes: ['Deal'],
    targetTypes: ['Organization'],
    props: [],
  },
  INVESTING_FROM: {
    type: 'INVESTING_FROM',
    schema: EmptyEdgePropsSchema,
    displayName: 'Investing From',
    reverseDisplayName: 'Investing In',
    sourceTypes: ['Deal'],
    targetTypes: ['Vehicle'],
    props: [],
  },
  // Note: Deal → Investment relationship is handled by ORIGINATED_FROM in pevc-portfolio.ts
  // (Investment → Deal, reverse: "Led To")
};
